import { Alert } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  position: relative;
  margin: 0 auto ${rem(24)} auto;
  align-items: start;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.error};
  line-height: 140%;

  div,
  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  a {
    color: ${({ theme }) => theme.colors.text.error};
    text-decoration-line: underline;
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};

    &:hover {
      color: ${({ theme }) => theme.colors.text.error};
    }
  }
`;
